import React, { useState, useRef, useEffect } from "react";
import "./TimeInput.css";
import { createPortal } from "react-dom";

const hours = Array.from({ length: 12 }, (_, i) => i + 1);
const minutes = Array.from({ length: 12 }, (_, i) => i * 5);
const periods = ["AM", "PM"];

const TimeInput = ({ value, onChange }) => {
  const [showPicker, setShowPicker] = useState(false);

  const wrapperRef = useRef();
  const inputRef = useRef();
  const dropdownRef = useRef(); // ✅ NEW

  const [position, setPosition] = useState({
    top: 0,
    left: 0,
  });

  const [hour, setHour] = useState(1);
  const [minute, setMinute] = useState(0);
  const [period, setPeriod] = useState("AM");

  // ✅ FIXED click outside logic
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        setShowPicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Update parent value
  useEffect(() => {
    const formatted = `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")} ${period}`;
    onChange && onChange(formatted);
  }, [hour, minute, period]);

  // Open picker
  const handleOpen = () => {
    const rect = inputRef.current.getBoundingClientRect();

    setPosition({
      top: rect.bottom,
      left: rect.left,
    });

    setShowPicker(true);
  };

  return (
    <div className="time-input-wrapper" ref={wrapperRef}>
      {/* INPUT */}
      <input
        ref={inputRef}
        type="text"
        value={value}
        readOnly
        onClick={handleOpen}
        className="time-input"
        placeholder="Select Time"
      />

      {/* DROPDOWN */}
      {showPicker &&
        createPortal(
          <div
            ref={dropdownRef} // ✅ IMPORTANT
            className="time-picker-dropdown"
            style={{
              position: "absolute",
              top: position.top + window.scrollY,
              left: position.left + window.scrollX,
              zIndex: 9999,
            }}
          >
            {/* HOURS */}
            <div className="time-column">
              {hours.map((h) => (
                <div
                  key={h}
                  className={`time-item ${hour === h ? "active" : ""}`}
                  onClick={() => setHour(h)}
                >
                  {h.toString().padStart(2, "0")}
                </div>
              ))}
            </div>

            {/* MINUTES */}
            <div className="time-column">
              {minutes.map((m) => (
                <div
                  key={m}
                  className={`time-item ${minute === m ? "active" : ""}`}
                  onClick={() => setMinute(m)}
                >
                  {m.toString().padStart(2, "0")}
                </div>
              ))}
            </div>

            {/* AM / PM */}
            <div className="time-column">
              {periods.map((p) => (
                <div
                  key={p}
                  className={`time-item ${period === p ? "active" : ""}`}
                  onClick={() => {
                    setPeriod(p);
                    setShowPicker(false); // ✅ optional close after selection
                  }}
                >
                  {p}
                </div>
              ))}
            </div>
          </div>,
          document.body,
        )}
    </div>
  );
};

export default TimeInput;
